import { useEffect } from "react";

import { convertTimestampToDateNumber } from "@simplyk/common";
import { enqueueSnackbar } from "notistack";

import { AmplitudeEvents } from "../../../../../common/constants/amplitude";
import { useCurrentUserContext } from "../../../../../common/contexts/CurrentUserContext";
import { trpc } from "../../../../../common/helpers/trpc";
import { useLiveFormAmplitudeEvents } from "../../common/amplitude/useLiveFormAmplitudeEvents";
import { useLiveFormEditorContext } from "../../common/LiveFormEditorContext";

export const useActivateTicketing = () => {
  const { apiFormObject: apiTicketing, updateApiFormObject, isOnboarding } = useLiveFormEditorContext<"ticketing">();
  const { organization } = useCurrentUserContext();
  const { logUserActionEvent } = useLiveFormAmplitudeEvents();
  const activateTicketingMutation = trpc.activateTicketing.useMutation();

  const status = apiTicketing.status;

  useEffect(() => {
    const activateTicketing = async () => {
      if (status === "draft") {
        logUserActionEvent(AmplitudeEvents.FormCreated, {
          organization_creation_date: organization?.createdAtUtc
            ? convertTimestampToDateNumber(organization.createdAtUtc)
            : null,
        });
        const { data: updatedTicketingResult, error } = await activateTicketingMutation.mutateAsync({
          ticketingId: apiTicketing.id,
          isOnboarding,
        });

        if (error) {
          enqueueSnackbar(error?.message, {
            vibe: "danger",
          });
          return;
        }

        if (updatedTicketingResult) {
          updateApiFormObject({
            ...apiTicketing,
            path: updatedTicketingResult.path,
            status: updatedTicketingResult.status,
          });
        }
      }
    };

    activateTicketing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiTicketing.id]); // We voluntarily activate only if id change (and not status)
};
